export const measureSwitcher = (prevMeasure) => {
    if (prevMeasure === 1000000) {
        return 1000
    } else if (prevMeasure === 1000) {
        return 1
    } else {
        return 1000000
    }
}